import { OccConfig, ProductScope } from '@spartacus/core';

export const defaultOccProductConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          default:
            'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),baseOptions,baseProduct,variantOptions,variantType,packagingWeight,modelNumber,customerPartNumber,partNumber,catalogNumber,completeName',
          list: 'products/${productCode}?fields=code,name,summary,price(formattedValue),images(FULL,galleryIndex),baseProduct',
          details:
            'products/${productCode}?fields=averageRating,stock(DEFAULT),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(FULL),priceRange,yourPrice,differencePrice,multidimensional,tags,images(FULL),videoUrls,image360(FULL),assetTypes,keySpecs,packagingWeight,packagingWeightUom,modelNumber,customerPartNumber,partNumber,catalogNumber,topCategory,substituteProduct,allowProductConfiguration,completeName',
          promotions: 'products/${productCode}?fields=potentialPromotions(description)',
          attributes: 'products/${productCode}?fields=classifications',
          price: 'products/${productCode}?fields=price(formattedValue)',
          stock: 'products/${productCode}?fields=stock(DEFAULT)',
          list_item:
            'products/${productCode}?fields=code,name,completeName,price(formattedValue),yourPrice,differencePrice,images(DEFAULT),baseProduct,averageRating,customerPartNumber,partNumber,catalogNumber,substituteProduct,completeName',
        },

        productReviews: 'products/${productCode}/reviews',
        productReferences: 'products/${productCode}/references?fields=DEFAULT,references(target(images(FULL)))',
        productSearch:
          'products/search?fields=products(code,name,completeName,summary,configurable,configuratorType,multidimensional,price(FULL),yourPrice,differencePrice,images(DEFAULT),stock(FULL),averageRating,variantOptions,discontinued,catalogNumber,partNumber,keySpecs,customerPartNumber,topCategory,substituteProduct),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
        productSuggestions: 'products/suggestions',
      },
    },
    loadingScopes: {
      product: {
        details: {
          include: [ProductScope.LIST, ProductScope.VARIANTS],
        },
      },
    },
  },
};
